<template>
    <div class="chat-main">
        <el-card class="box-card" :style="{ height: chatheight + 'px' }">
            <div slot="header" class="clearfix">
                <el-row>
                    <el-col :span="20">
                        <span>聊天室</span>
                    </el-col>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                    <el-col :span="4">
                        <el-select v-model="sendTo" size="mini">
                            <el-option value="All">全部</el-option>
                            <el-option v-for="(user, index) in userList" :value="user" :key="index">{{ user
                                }}</el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>
            <div>
                <el-row>
                    <el-col :span="20">
                        <el-input id="text" type="text" v-model="message" />
                    </el-col>
                    <el-col :span="4" style="padding-left: 10px;">
                        <el-button type="primary" v-on:click="sendMessage">发送消息</el-button>
                    </el-col>
                </el-row>
                <el-row style="padding:10px 0px;text-align: right;">
                    <el-button size="mini" v-on:click="openWebSocket">进入聊天室</el-button>
                    <el-button size="mini" v-on:click="closeWebSocket">退出聊天室</el-button>
                    <el-button size="mini" v-on:click="clearMessageList">清空聊天记录</el-button>
                </el-row>
            </div>
            <div :style="{ height: (chatheight - 190) + 'px' }" class="chat-div">
                <li v-for="(o, index) in messageList" :key="index" class="text-item" v-html="o"></li>
            </div>
        </el-card>
    </div>
</template>
<script>
export default {
    data () {
        return {
            sendTo: 'All',
            message: '',
            username: prompt('请输入用户名', ''),
            userList: null,
            messageList: [],
            websocket: null,
            chatheight: 0
        }
    },
    created () {
        this.chatheight = window.innerHeight - 45
        this.openWebSocket()
    },
    methods: {
        openWebSocket: function () {
            let self = this
            var isSupport = 'WebSocket' in window
            if (!isSupport) {
                var message = self.formatMessage(new Date(), '系统消息', '当前浏览器不支持WebSocket')
                self.messageList = self.messageList == null ? message : self.messageList + '<br/>' + message
                return
            }

            this.websocket = new WebSocket('wss://teacher.xinzhitang.com.cn/ws?username=' + this.username)

            // 链接错误得回调方法
            this.websocket.onerror = function () {
                var message = self.formatMessage(new Date(), '系统消息', '连接发生错误')
                self.messageList.push(message)
            }

            // 连接成功建立的回调方法
            this.websocket.onopen = function () {
                var message = self.formatMessage(new Date(), '系统消息', '进入聊天室')
                self.messageList.push(message)
                self.sendEvent('Joined')
            }

            // 接收到消息的回调方法
            this.websocket.onmessage = function (event) {
                var entity = JSON.parse(event.data)
                if (entity.Type === 'Event') {
                    var eventData = JSON.parse(entity.Message)
                    self.userList = eventData.Data.filter(function (data) {
                        return data !== self.username
                    })
                } else {
                    var message = self.formatMessage(entity.SendTime, entity.Sender, entity.Message)
                    self.messageList.push(message)
                }
            }

            // 连接关闭的回调方法
            this.websocket.onclose = function () {
                var message = self.formatMessage(new Date(), '系统消息', '退出聊天室')
                self.messageList.push(message)
            }

            // 监听窗口关闭事件
            window.onbeforeunload = function () {
                if (self.websocket == null) {
                    return
                }

                self.closeWebSocket()
            }
        },

        closeWebSocket: function () {
            if (this.websocket == null) {
                return
            }

            this.sendEvent('Leaved')
            this.websocket.close()
        },

        sendMessage: function () {
            if (this.websocket == null) {
                return
            }

            if (this.message == null || this.message === '') {
                alert('不允许发送空消息')
                return
            }
            this.websocket.send(JSON.stringify({
                'sender': this.username,
                'receiver': this.sendTo,
                'message': this.message,
                'sendTime': new Date().toISOString()
            }))

            var message = this.formatMessage(new Date(), this.username, this.message)
            this.messageList.push(message)
            this.message = null
        },

        sendEvent: function (eventName) {
            if (this.websocket == null) {
                return
            }

            var eventData = JSON.stringify({
                'event': eventName,
                'data': null
            })

            this.websocket.send(JSON.stringify({
                'type': 'event',
                'sender': this.username,
                'message': eventData,
                'sendTime': new Date().toISOString()
            }))
        },

        formatMessage: function (sendTime, sender, message) {
            return '<span class="span-time">' + new Date().toLocaleString() + '</span> - <span class="span-sender">' + sender + '</span> : <span>' + message + '</span>'
        },

        clearMessageList: function () {
            this.messageList = null
        }
    }
}
</script>
<style lang="less" scoped>
.chat-div {
    border: 1px solid #E4E7ED;
    border-radius: 5px;
    overflow-y: auto;
}

.box-card {
    margin-top: 20px;
}

.chat-main {
    margin: 0 auto;
    width: 50%;
}

.text-item {
    padding: 5px 10px;
}

/deep/.span-sender {
    color: #E6A23C;
    font-weight: 700;
}

/deep/.span-time {
    color: #C0C4CC;
}

li {
    list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/websocket/client.vue